import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import './App.css'
import Home from './pages/Home'
import Menu from './pages/Menu'
import About from './pages/About'
import Gallery from './pages/Gallery'
import Contact from './pages/Contact'

function App() {
  return (
    <Router>
      <div className="App bg-gray-50 min-h-screen">
        <nav className="bg-primary text-white p-4 shadow-lg">
          <div className="container mx-auto flex gap-6 items-center">
            <Link to="/" className="text-xl font-bold hover:underline">TechStaff Solutions</Link>
            <Link to="/" className="hover:underline">Home</Link>
            <Link to="/menu" className="hover:underline">Menu</Link>
            <Link to="/about" className="hover:underline">About</Link>
            <Link to="/gallery" className="hover:underline">Gallery</Link>
            <Link to="/contact" className="hover:underline">Contact</Link>
          </div>
        </nav>
        <main className="min-h-screen">
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <footer className="bg-gray-800 text-white p-8 mt-16">
          <div className="container mx-auto text-center">
            <p>&copy; {new Date().getFullYear()} TechStaff Solutions. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </Router>
  )
}

export default App
